var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 30,
    viewBox: "0 0 177 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.914528
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10.9946,
    width: 2.8457,
    height: 6.82969,
    rx: 1.42285,
    fill: "#3F6EB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.36328,
    y: 5.01855,
    width: 2.8457,
    height: 18.7816,
    rx: 1.42285,
    fill: "#3F6EB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.82129,
    y: 8.62305,
    width: 2.8457,
    height: 11.5725,
    rx: 1.42285,
    fill: "#3F6EB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.375,
    y: 11.374,
    width: 2.8457,
    height: 6.07083,
    rx: 1.42285,
    fill: "#4BAEE1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6436,
    y: 8.52832,
    width: 2.8457,
    height: 11.7622,
    rx: 1.42285,
    fill: "#4BAEE1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.0068,
    y: 5.01855,
    width: 2.8457,
    height: 18.8765,
    rx: 1.42285,
    fill: "#4BAEE1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2754,
    y: 11.1843,
    width: 2.8457,
    height: 6.45026,
    rx: 1.42285,
    fill: "#E7A846"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.6387,
    y: 8.52832,
    width: 2.84571,
    height: 11.7622,
    rx: 1.42285,
    fill: "#E7A846"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.0977,
    y: 5.11353,
    width: 2.8457,
    height: 18.5919,
    rx: 1.42285,
    fill: "#E7A846"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3662,
    y: 0.75,
    width: 2.8457,
    height: 27.3187,
    rx: 1.42285,
    fill: "#E7A846"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.7285,
    y: 8.52832,
    width: 2.8457,
    height: 11.7622,
    rx: 1.42285,
    fill: "#B6BECE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1875,
    y: 11.374,
    width: 2.84571,
    height: 6.07083,
    rx: 1.42285,
    fill: "#B6BECE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.914528
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1919 14.5005C75.1919 12.2036 74.4741 10.2451 73.2847 8.96338C72.085 7.69189 70.3931 6.96387 68.4756 6.96387C66.4966 6.96387 64.7637 7.67139 63.5435 8.93262C62.313 10.1938 61.585 12.1113 61.585 14.3979C61.585 16.7256 62.2207 18.5713 63.4819 19.9453C64.7432 21.3193 66.4043 22.0063 68.4756 22.0063C70.3726 22.0063 72.0542 21.2988 73.2539 20.0376C74.4536 18.7764 75.1919 16.8281 75.1919 14.5005ZM73.8076 14.521C73.8076 18.7661 71.2236 20.7656 68.4551 20.7656C66.8042 20.7656 65.4814 20.2017 64.4868 19.084C63.4922 17.9663 62.9897 16.377 62.9897 14.3159C62.9897 12.3984 63.605 10.7886 64.5996 9.78369C65.5942 8.77881 66.9375 8.2251 68.4551 8.2251C69.9214 8.2251 71.2236 8.77881 72.208 9.79395C73.1924 10.8193 73.8076 12.4805 73.8076 14.521Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4932 16.0591C80.4932 16.9614 80.5547 17.6997 80.6777 18.2842C81.2212 20.7656 83.0054 22.0063 86.0098 22.0063C89.1167 22.0063 90.9214 20.6938 91.4341 18.0791C91.5264 17.5562 91.5776 16.8794 91.5776 16.0591V7.24072H90.2344V16.0181C90.2344 16.7461 90.1831 17.3716 90.0703 17.8843C89.6499 19.812 88.3579 20.7656 86.0303 20.7656C83.7231 20.7656 82.4311 19.8325 81.98 17.9458C81.8672 17.5049 81.8159 16.8589 81.8159 16.0181V7.24072H80.4932V16.0591Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.539 8.52246H107.492V7.24072H96.2534V8.52246H101.165V21.75H102.539V8.52246Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.668 20.4683H113.459V7.24072H112.137V21.75H120.668V20.4683Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.29 14.5005C137.29 12.2036 136.572 10.2451 135.382 8.96338C134.183 7.69189 132.491 6.96387 130.573 6.96387C128.594 6.96387 126.861 7.67139 125.641 8.93262C124.411 10.1938 123.683 12.1113 123.683 14.3979C123.683 16.7256 124.318 18.5713 125.58 19.9453C126.841 21.3193 128.502 22.0063 130.573 22.0063C132.47 22.0063 134.152 21.2988 135.352 20.0376C136.551 18.7764 137.29 16.8281 137.29 14.5005ZM135.905 14.521C135.905 18.7661 133.321 20.7656 130.553 20.7656C128.902 20.7656 127.579 20.2017 126.584 19.084C125.59 17.9663 125.087 16.377 125.087 14.3159C125.087 12.3984 125.703 10.7886 126.697 9.78369C127.692 8.77881 129.035 8.2251 130.553 8.2251C132.019 8.2251 133.321 8.77881 134.306 9.79395C135.29 10.8193 135.905 12.4805 135.905 14.521Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.591 16.0591C142.591 16.9614 142.652 17.6997 142.775 18.2842C143.319 20.7656 145.103 22.0063 148.107 22.0063C151.214 22.0063 153.019 20.6938 153.532 18.0791C153.624 17.5562 153.675 16.8794 153.675 16.0591V7.24072H152.332V16.0181C152.332 16.7461 152.281 17.3716 152.168 17.8843C151.748 19.812 150.456 20.7656 148.128 20.7656C145.821 20.7656 144.529 19.8325 144.078 17.9458C143.965 17.5049 143.914 16.8589 143.914 16.0181V7.24072H142.591V16.0591Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.304 21.75C164.073 21.75 164.862 21.6885 165.652 21.5757C166.441 21.4629 167.098 21.3091 167.61 21.104C170.03 20.1094 171.24 17.8638 171.24 14.3569C171.24 11.209 170.133 8.93262 167.887 7.90723C166.964 7.46631 165.529 7.24072 163.581 7.24072H159.715V21.75H163.304ZM161.038 8.52246H163.827C165.437 8.52246 166.636 8.74805 167.426 9.20947C168.256 9.69141 168.861 10.3887 169.261 11.3013C169.661 12.2139 169.856 13.2393 169.856 14.3569C169.856 17.0127 168.984 18.9507 167.313 19.8018C166.872 20.0171 166.308 20.1812 165.621 20.2939C164.924 20.4067 164.268 20.4683 163.642 20.4683H161.038V8.52246Z",
    fill: "#171717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6a0bb1024a8e6fbd2e254c152b98747.svg";
export { ForwardRef as ReactComponent };